<template>
  <el-date-picker
  type="daterange"
  :picker-options="pickerOptions"
  range-separator="至"
  start-placeholder="开始日期"
  end-placeholder="结束日期"
  format="yyyy-MM-dd"
  v-model="value"
  align="right"
  style="width: 100%;">
  </el-date-picker>
</template>

<script>
import moment from 'moment'
export default {
  props: {
    start: {
      type: String,
      default: ''
    },
    end: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      value: this.start && this.end ? [new Date(this.start), new Date(this.end)] : ''
    }
  },
  computed: {
    timeWatch: function() {
      return {
        start: this.start,
        end: this.end
      }
    }
  },
  watch: {
    timeWatch: {
      handler(obj) {
        const {
          start,
          end
        } = obj
        this.value = start && end ? [new Date(start), new Date(end)] : ''
      }
    },
    value: {
      handler(val) {
        let dateArr = []
        if (val) {
          dateArr = [
            moment(val[0]).format('YYYY-MM-DD'),
            moment(val[1]).format('YYYY-MM-DD')
          ]
        } else {
          dateArr = ['', '']
        }
        this.$emit('onDatePicker', dateArr)
      },
      immediate: true
    }
  }
}
</script>
